/**
 * PPE 평가 항목 키값 매핑 데이터
 * 
 * 각 키값(localizeKey)을 평가항목명과 내용으로 매핑
 */

export interface PpeMappingItem {
	key: string;
	evaluationItem: string;
	content: string;
}

export const PPE_MAPPING_DATA: PpeMappingItem[] = [
	// 사용자 제공 원본 데이터 그대로 매핑 (착의·탈의 순서대로)
	
	// Basic PPE 착의
	{ key: 'PPE.LevelD.HandHygiene', evaluationItem: '손위생', content: '손소독을 한다.' },
	{ key: 'PPE.BasicPPE.WearingInnerGloves', evaluationItem: '속장갑 착용', content: '속장갑을 착용한다.' },
	{ key: 'PPE.BasicPPE.WearingGown', evaluationItem: '가운착용', content: '가운을 입는다. 속장갑으로 가운소매를 덮는다.' },
	{ key: 'PPE.BasicPPE.WearingMask', evaluationItem: 'N95 마스크 착용', content: '마스크를 착용하고, 손가락으로 마스크의 코 접촉 부위를 눌러 밀착시킨다. 양손으로 마스크를 움켜쥐고 숨을 내쉬고 들이마시면서 새는 곳이 없는지 확인한다.' },
	{ key: 'PPE.BasicPPE.WearingGoggle', evaluationItem: '안면보호구 착용', content: '고글이나 안면보호구를 착용한다.' },
	{ key: 'PPE.BasicPPE.WearingHaircap', evaluationItem: '헤어캡 착용', content: '이마 앞쪽부터 뒤로 당기며 머리 전체에 덮어 씁니다. 귀, 옆머리, 뒷머리, 잔머리가 밖으로 빠져나오지 않도록 정리한다.' },
	{ key: 'PPE.BasicPPE.WearingPlasticGown', evaluationItem: '비닐가운 착용', content: '비닐가운을 착용한 후, (소매 끝 엄지 고리에 손가락을 끼운다.)' },
	{ key: 'PPE.BasicPPE.WearingOuterGloves', evaluationItem: '겉장갑 착용', content: '장갑의 소매가 비닐 가운의 소매 위를 완전히 덮도록 길게 당겨서 착용한다.' },
	{ key: 'PPE.BasicPPE.Completion', evaluationItem: '착의완료', content: '최종 착의 상태를 점검한다.' },
	
	// Basic PPE 탈의
	{ key: 'PPE.HandHygiene', evaluationItem: '손위생', content: '손소독을 한다.' },
	{ key: 'PPE.BasicPPE.RemovePlasticGown', evaluationItem: '비닐가운 및 겉장갑 제거', content: '비닐가운을 착용한 경우, 비닐가운과 함께 겉장갑을 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.BasicPPE.RemoveGown', evaluationItem: '가운탈의', content: '가운의 끈을 풀고 가운 겉면이 신체에 닿지 않도록 주의하여 바깥으로 말아주면서 탈의한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.BasicPPE.RemoveHaircap', evaluationItem: '헤어캡 제거', content: '오염 물질에 얼굴에 떨어지지 않도록 바닥을 향해 고개를 숙인채, 뒤통수 쪽 헤어캡 가장자리 안쪽으로 손가락을 살짝 집어넣어 잡고 이마방향으로 홀라당 뒤집으며 벗는다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.BasicPPE.RemoveGoggle', evaluationItem: '안면보호구 제거', content: '안면보호구 혹은 고글 앞면을 만지지 않고 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.BasicPPE.RemoveN95Mask', evaluationItem: 'N95 마스크 제거', content: '마스크를 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.BasicPPE.RemoveInnerGloves', evaluationItem: '속장갑 제거', content: '장갑 안쪽에 손가락을 넣어 뒤집으며 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	
	// Level D 착의
	{ key: 'PPE.LevelD.WearingInnerGloves', evaluationItem: '속장갑 착용', content: '속장갑을 착용한다.' },
	{ key: 'PPE.LevelD.WearingPPE', evaluationItem: '보호복 착용', content: '전신 보호복을 착용한다.' },
	{ key: 'PPE.LevelD.WearingPPEThumb', evaluationItem: '엄지고리 끼기', content: '소매 끝 엄지고리에 손가락을 끼운다.' },
	{ key: 'PPE.LevelD.WearingShoeCover', evaluationItem: '덧신 착용', content: '보호복 바지단이 덧신 위로 빠져나오지 않도록 덧신 안으로 김숙이 밀어 넣어 착용한다.' },
	{ key: 'PPE.LevelD.TyingShoeCover', evaluationItem: '덧신 매듭묶기', content: '끈 매듭이 길게 늘어지지 않도록 리본 모양으로 단단히 묶고, 남은 끈은 안쪽으로 말아 넣는다.' },
	{ key: 'PPE.LevelD.WearingMask', evaluationItem: 'N95 마스크 착용', content: 'N95 마스크를 착용하고, 손가락으로 마스크의 코 접촉 부위를 눌러 밀착시킨다. 양손으로 마스크를 움켜쥐고 숨을 내쉬고 들이마시면서 새는 곳이 없는지 확인한다.' },
	{ key: 'PPE.LevelD.WearingGoggle', evaluationItem: '고글 착용', content: '고글을 착용한다.' },
	{ key: 'PPE.LevelD.WearingHood', evaluationItem: '후드 착용', content: '보호복 후드를 착용하고 지퍼 테이프로 밀봉한다.' },
	{ key: 'PPE.LevelD.WearingOuterGloves', evaluationItem: '겉장갑 착용', content: '겉장갑을 착용하고, 옷소매 위를 덮어 소매가 노출되지 않도록 착용한다.' },
	{ key: 'PPE.LevelD.Completion', evaluationItem: '착용완료', content: '최종 착용상태 점검한다.' },
	
	// Level D 탈의
	{ key: 'PPE.LevelD.InfectantRemoval', evaluationItem: '오염물질 제거', content: '소독티슈로 오염물질을 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.LevelD.UntieTheKnot', evaluationItem: '덧신매듭풀기', content: '탈의시작 전 덧신매듭을 먼저 풀어놓는다.' },
	{ key: 'PPE.LevelD.RemoveOuterGloves', evaluationItem: '겉장갑제거', content: '한 손으로 반대편 장갑의 겉면을 잡고 벗겨 손에 쥐고, 장갑이 벗겨진 손으로 남은 장갑의 안쪽 면을 벗겨 말아서 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.LevelD.RemovePPE', evaluationItem: '보호복 탈의', content: '지퍼를 내린 후, 후드부터 시작해 겉면을 안쪽으로 똘똘 말아가며 다리까지 내린 뒤 덧신과 함께 탈의한다. (오염물이 공기로 날아가지 않도록 보호복이 펄럭이지 않도록 유의) 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.LevelD.RemoveFaceProtection', evaluationItem: '안면보호구 제거', content: '정면이 아닌 바닥을 향해 고개를 숙이고 눈을 감은 상태에서 끈을 당겨 고글을 벗는다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.LevelD.RemoveN95Mask', evaluationItem: 'N95 마스크 제거', content: '필터 부위를 만지지 않고 귀나 머리 끈만 잡고 고개를 숙인 채 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
	{ key: 'PPE.LevelD.RemoveInnerGloves', evaluationItem: '속장갑 제거', content: '장갑 안쪽에 손가락을 넣어 뒤집으며 제거한다. 이후 의료폐기물 전용 용기에 버린다.' },
];

/**
 * PPE 키값으로 평가항목·내용 조회
 */
export function getPpeMappingByKey(key: string): PpeMappingItem | undefined {
	return PPE_MAPPING_DATA.find((item) => item.key === key);
}

/**
 * PPE 키값으로 평가항목명 조회
 */
export function getPpeEvaluationItem(key: string): string {
	const mapping = getPpeMappingByKey(key);
	return mapping?.evaluationItem ?? key;
}

/**
 * PPE 키값으로 내용 조회
 */
export function getPpeContent(key: string): string {
	const mapping = getPpeMappingByKey(key);
	return mapping?.content ?? '';
}
